module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "fr-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062237088_Contents#fr"
    }
  }, [_c('span', {
    staticClass: "blue"
  }, [_vm._v("BEFORE YOU BEGIN:")])])]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062237088_Contents#fr"
    }
  }, [_c('span', {
    staticClass: "blue1"
  }, [_vm._v("THE HEART OF YOUR WEDDING")])])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('div', {
    staticClass: "hr-bottom"
  }, [_c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("You’re engaged! As the couple of the moment, it’s likely that you’re in a whirlwind of rejoicing with your parents and friends and picturing a life of married bliss. With all the excitement comes another vision—that of a perfect wedding. But what does “perfect” mean? For one thing, it no longer describes only the storybook formal event with six bridesmaids and yards of white tulle. In truth, the ideal wedding is one that is a reflection of who you are as a couple; is considerate, inclusive, and patient with your closest family; and takes your guests’ comfort into account at all times. Today’s idea of “perfection” is about planning your wedding and any related celebrations with the following ideas in mind:")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "6",
      "src": "images/star.jpg",
      "width": "9"
    }
  }), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Let consideration be your guide. Make decisions based on maintaining and caring for the important relationships in your lives.")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "6",
      "src": "images/star.jpg",
      "width": "9"
    }
  }), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Rely on diplomacy: Employ tact and sensitivity when involving others—including stepparents and extended family members.")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "6",
      "src": "images/star.jpg",
      "width": "9"
    }
  }), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Give thought to the kind of occasion that you, your family, and friends will feel comfortable with and enjoy.")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "6",
      "src": "images/star.jpg",
      "width": "9"
    }
  }), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Try to include traditions that mean a great deal to someone important to you. Forgo a tradition if it doesn’t make sense for you or if it could cause more problems than it would solve.")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "6",
      "src": "images/star.jpg",
      "width": "9"
    }
  }), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Be considerate of your guests with special needs, such as elders, parents with very young children, or guests with disabilities. Find ways to give children special roles if they’re included.")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "6",
      "src": "images/star.jpg",
      "width": "9"
    }
  }), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Anticipate and take steps to avoid potential problems that may lead to friction. Give people time to adjust to decisions that might not be their first choice.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1"
  }, [_vm._v("The same attention and respect you give your family and guests applies to your relationship with suppliers and contractors. No matter the size or budget of your wedding, your goal is to form positive, collaborative relationships with everyone providing you with wedding services.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Keeping Joy in the Process")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Planning a wedding is a time of joy and community that can bring people together in the most wonderful of ways. At the same time, this closeness can breed friction, and the land mines involved in making deeply emotional (and expensive) decisions can detonate unexpectedly. Take care that your family and close friends feel included in the planning. Most important, you’ll want to find ways to take good care of yourself and your fiancé(e) so that you can enjoy the planning. There are also "), _c('i', [_vm._v("Emily Post’s Wedding Planner")]), _vm._v(", the companion to this book, and www.emilypost.com to help keep you organized along the way. Here is some tried-and-true advice to help smooth your wedding preparations:")]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_c('b', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("You’re a team.")])]), _vm._v(" The two of you need to be a united front and, most important, each other’s support amid a barrage of sometimes conflicting wedding advice or unexpected pressure as you make the big decisions. Although such advice is well meant, it can also be overwhelming to sort through. Help each other stay grounded and focused.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_c('b', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Remember the three C’s.")])]), _vm._v(" Always keep your focus on the three C’s of good relationships:")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "6",
      "src": "images/star.jpg",
      "width": "9"
    }
  }), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Consideration")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "6",
      "src": "images/star.jpg",
      "width": "9"
    }
  }), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Communication")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "6",
      "src": "images/star.jpg",
      "width": "9"
    }
  }), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Compromise")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1"
  }, [_vm._v("How you handle the decisions involved in your wedding plans can set the tone for how you’ll handle the other major decisions in your life together. This is the time to develop a way of reaching consensus—or good compromises.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_c('b', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Delegate duties.")])]), _vm._v(" Others will want to help, and what bride and groom couldn’t use some assistance? You may discover how fortunate you are to have friends and family willing to help out. Your wedding day may be the most important time to delegate tasks so that you can focus on your ceremony and enjoy the reception afterward.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Once you have relinquished a responsibility, don’t dwell on it, second-guess yourself or others, or micromanage. When you’ve put someone in charge, let others know. For example, tell the florist your sister is in charge of flowers and to contact her, not you, or have your fiancé(e) contact the tent supplier and arrange all of the details.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_c('b', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Stay organized.")])]), _vm._v(" It doesn’t take long for chaos to reign if you don’t have some sort of system of organization. Whether you use the "), _c('i', [_vm._v("Emily Post Wedding Planner")]), _vm._v(", an online site, or an app; set up computer files; or devote a binder or filing drawer just to wedding-related papers, you’ll find everything is easier to manage when you can locate it quickly. Here are a few tips from the most efficient brides and grooms:")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "6",
      "src": "images/star.jpg",
      "width": "9"
    }
  }), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Create a master to-do list, preferably in time sequence.")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "6",
      "src": "images/star.jpg",
      "width": "9"
    }
  }), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Keep fabric swatches, photos of gowns, photos of locations, and table measurements with you—either physically or on your phone or tablet—in case you get a phone call while you’re out.")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "6",
      "src": "images/star.jpg",
      "width": "9"
    }
  }), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Design a contact list with the names of everyone you’re working with, including email and business addresses, web address, phone and even fax numbers.")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "6",
      "src": "images/star.jpg",
      "width": "9"
    }
  }), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Carry a paper or digital calendar with all your appointments highlighted, and set alerts for them on your smartphone.")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "6",
      "src": "images/star.jpg",
      "width": "9"
    }
  }), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Create a paper or electronic folder for all contracts. Staple copies of contracts to the appropriate pages in your organizer or scan completed contracts and file them electronically. Don’t leave home without them—either in your binder or on your phone or tablet—in case you have to check details from one supplier when working with another.")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "6",
      "src": "images/star.jpg",
      "width": "9"
    }
  }), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Keep copies of important papers you will need (birth certificates, any divorce papers, driver’s licenses) in one envelope or folder. Again, it’s a good idea to scan and save these documents electronically.")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "6",
      "src": "images/star.jpg",
      "width": "9"
    }
  }), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Check off completed to-dos as you accomplish them. Seeing the number of check marks grow will feel great!")]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_c('b', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Stay calm.")])]), _vm._v(" Even if you’ve lived together or are an older couple with grown children, don’t let the details bog you down or send you into an emotional tailspin; when things get tough, keep reminding yourself that it’s the marriage, not the wedding, that’s important. Try to step back and imagine the view from 30,000 feet. Here are three ways to keep things on an even keel:")]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    staticClass: "gray"
  }, [_vm._v("1."), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Include, don’t exclude.")])]), _vm._v(" Even if you’re doing everything yourselves, keep others—your mothers, children, or friends—in the loop. Don’t let them feel left out. You may see yourself as adding to your family with this wedding, but your family may feel they are losing you. Give them extra attention. Ask their advice periodically—but not about things you’ve already decided on, or you’ll have to either reject their advice or change your plans and give up something you really want to do.")]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    staticClass: "gray"
  }, [_vm._v("2."), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Be forgiving.")])]), _vm._v(" When things get touchy between you and your family (or your fiancé(e)!), make an effort to get things back on the right foot, which might mean being the first to apologize.")]), _vm._v(" "), _c('p', {
    staticClass: "numlist"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_c('span', {
    staticClass: "gray"
  }, [_vm._v("3."), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Stop reacting.")])]), _vm._v(" If someone is being difficult, take a deep breath and think about what might be motivating them. Is your brother feeling left out of your life? Is your mom worried about what your relationship will be with her once you’re married? If you can’t figure it out, have a calm chat with them and ask what is upsetting them. (Don’t go into a conversation like this with a bone of your own to pick—the goal is to be understanding and helpful.)")]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_c('b', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Take care of your relationship with your fiancé(e).")])]), _vm._v(" Throughout your engagement, remember to make time to enjoy each other. Take time out with scheduled date nights that are “wedding free.”")]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_c('b', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Take care of yourselves.")])]), _vm._v(" To keep yourselves from burning out:")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "6",
      "src": "images/star.jpg",
      "width": "9"
    }
  }), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Eat right—you need the energy.")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "6",
      "src": "images/star.jpg",
      "width": "9"
    }
  }), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Exercise—you need the release (and you’ll look great, too!)")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "6",
      "src": "images/star.jpg",
      "width": "9"
    }
  }), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Get enough sleep—you can think much better when you’re rested.")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "6",
      "src": "images/star.jpg",
      "width": "9"
    }
  }), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Look for the bright side when things don’t go your way—and when you can’t . . .")]), _vm._v(" "), _c('p', {
    staticClass: "bulllist"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "height": "6",
      "src": "images/star.jpg",
      "width": "9"
    }
  }), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Find humor.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Family Matters")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("As much as your commitment to marry is between you as a couple, you each bring your own families along with you. We can’t stress enough how important it is to commit to getting to know each other’s families. This means accepting them for who they are and giving them the benefit of the doubt when something hits a nerve. Keep your communications open and clear, but if there is a misunderstanding or disagreement, remember to support each other first and foremost. At the end of the day, your goal is to build good relationships with people who mean a tremendous amount to your future partner.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("If your family or families are complicated by divorce, remarriage, step relationships, or family feuding, give serious thought to these issues as early in the planning process as possible. Your marriage is highly unlikely to heal rifts among family members, but with forethought and tact, you can prepare yourself to head off serious difficulties.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Unfortunately, divorced parents aren’t always on friendly terms. Although most adults will lay their differences aside for a wedding, you should avoid putting divorced parents in awkward and uncomfortable situations. For example, seating divorced parents together at the ceremony or reception isn’t necessary. If you plan to have your stepdad walk you down the aisle, let your biological dad know well in advance so he has time to accept the idea. Most parents will do everything in their power to make your wedding special, but you have responsibilities to them as well, which may mean adjusting what you want to what others need.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The traditional wedding vows include the words "), _c('i', [_vm._v("for better and for worse")]), _vm._v(". Couples would be wise to apply these words to their families. Will your plans make difficult family relationships better or at least keep them on an even keel? When you look back on your wedding in ten or fifteen years, you’ll want to be proud of everything you did and remember a day that was happy for everyone.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("The 21st-Century Wedding")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Emily Post knew that the magic of a wedding lay less in the details than in the tender quality of the occasion and the radiance of the couple. “The radiance of a truly happy bride is so beautifying that even a plain girl is made pretty, and a pretty one, divine,” she wrote in "), _c('i', [_vm._v("Etiquette")]), _vm._v(" in 1922. “She and the groom both look as though there is sunlight behind their eyes, as though their mouths irresistibly turned to smiles.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("While that sentiment has stayed the same, weddings themselves haven’t. Changes in society, from a more culturally diverse population to the redefinition of the family, have revolutionized weddings today, giving rise to more informal ceremonies and the inclusion of customs and traditions reflecting the couple’s heritage. Weddings have become more adventurous and imaginative, with destination and theme weddings part of the evolution. They feature more guest-focused receptions and a more active role for the groom’s family. Here are some of the hallmarks of weddings today:")]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_c('b', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Personalized weddings.")])]), _vm._v(" This is one “trend” that seems here to stay. Many couples make a concerted effort to differentiate their wedding by planning intimate and individualized ceremonies and receptions that express their personalities and interests.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_c('b', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Financing the wedding.")])]), _vm._v(" The economic downturn has given wedding budgets a reality check. Today, wedding expenses are no longer the exclusive responsibility of the bride’s parents but are frequently shared by the couple, the bride’s and groom’s parents, or any combination of the three. More and more couples pay most or all of the expenses. With the average cost of a wedding clocking in around $27,000, it’s no wonder that “How will we pay for it?” is one of the first conversations that engaged couples have.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_c('b', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("The wedding weekend.")])]), _vm._v(" With so much to plan and many guests coming from afar, the wedding day has expanded to the wedding weekend. Many couples schedule events that bracket the wedding day for the wedding party and their guests to take advantage of the fact that their closest friends are already gathered together.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_c('b', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Good-bye, Bridezilla.")])]), _vm._v(" We have happily waved goodbye to the imperious, self-absorbed bride; instead couples are once again as focused on providing a meaningful, memorable experience for their guests as they are for themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_c('b', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Encore and family weddings.")])]), _vm._v(" Nearly 40 percent of today’s weddings are “encore” events, meaning that the bride, the groom, or both have been married before. More remarrying couples with children are hosting “family weddings” that actively involve their children in the ceremony and often have them join them during their vows, or as part of a statement of support.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_c('b', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Social media.")])]), _vm._v(" Social media, such as Facebook and Twitter, are deeply woven into the fabric of our everyday lives and extend naturally to sharing wedding news. Image sharing sites like Pinterest that help organize your inspirations are still emerging. These can make planning your wedding day easier and more fun. It’s also important to put on the brakes sometimes to avoid oversharing and to make your offline communication with friends and family your top priority, especially when first sharing news and plans about your wedding.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_c('b', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("More wedding attire choices.")])]), _vm._v(" Modern brides are continuing to express their individual taste and style in their attire. Wedding dresses and accessories increasingly include color, and many incorporate designs and fabrics that reflect the bride’s culture or ethnic heritage. Bridesmaids’ dresses allow for individuality, and are often chosen with complementary cuts or colors instead of all being identical. Black is no longer “out” for bridesmaids or female guests (or even very adventurous brides!), and though most guests still shy away from it, white can be acceptable for guests as well.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_c('b', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Colorful weddings.")])]), _vm._v(" Traditional white still reigns in many aspects of weddings, but color is also blooming in more than just the flowers, including attire, invitations and announcements, reception decorations and table linens, wedding cakes, and gift wrappings.")]), _vm._v(" "), _c('p', {
    staticClass: "normal-1"
  }, [_c('b', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("Destination weddings.")])]), _vm._v(" More couples continue to invite guests to join them in exotic and distant locations for their big day, with many guests turning the trip into an opportunity for a longer vacation. Even when it’s not an exotic locale, there’s a good chance that your wedding will involve travel plans for many of your guests.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "boxtitle"
  }, [_c('span', {
    staticClass: "border"
  }, [_vm._v("20/20 HINDSIGHT")])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("As we were writing this book, we reached out on The Emily Post Institute’s Facebook page to recently married brides and asked for their best piece of wedding advice. Here’s a sampling of what they were kind enough to share, along with good advice from past brides:")]), _vm._v(" "), _c('p', {
    staticClass: "normal-1t"
  }, [_c('b', [_vm._v("THE BIG PICTURE")])]), _vm._v(" "), _c('p', {
    staticClass: "normalat"
  }, [_vm._v("“Remember that ultimately, it isn’t about the wedding—it’s about the marriage.” —"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TANA")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("“Don’t put too much pressure on yourself for everything to be absolutely perfect. At the end of the day, if you’re married to the one you love, then that’s all that matters!” —"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERIN")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-1t"
  }, [_c('b', [_vm._v("BALANCE")])]), _vm._v(" "), _c('p', {
    staticClass: "normalat"
  }, [_vm._v("“Take advice graciously, but ultimately make your own decisions. You will be inundated with advice (both solicited and unsolicited!), which can become confusing.” —J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENNIFER")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("“Know your audience! It will help you have a balance of everything from music to food. Grandma does not want to dance to LMFAO! And your construction worker uncle wants an adequate amount of food so he does not have to go to fast food after dinner.” —"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("KRISTIN")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-1t"
  }, [_c('b', [_vm._v("DELEGATE")])]), _vm._v(" "), _c('p', {
    staticClass: "normalat"
  }, [_vm._v("“Hand over your cell phone to your maid of honor / best man / wedding planner—just make someone else your ‘point person’ that weekend and endow them with the power to make decisions on your behalf. Notify all your vendors and family of this. This was the best thing I did—then I could just enjoy the day and focus on getting married!” —"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NICOLE")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("“Don’t be afraid to ask for help and let others contribute in different ways to your special day. Involving close friends and family in different wedding-day elements can save you time and stress, plus it can bring loved ones joy to have had a hand in bringing your dream to life.” —"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALLISON")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("“Have someone designated to run the rehearsal. The bride and groom should be relaxed and just let that person stage-manage. Also, build in time for delays (traffic, logistics) for getting to the ceremony, photos, getting to reception, etc.” —"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TAMMY")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-1t"
  }, [_c('b', [_vm._v("GUEST LIST")])]), _vm._v(" "), _c('p', {
    staticClass: "normalat"
  }, [_vm._v("“I would invite everyone. I was so scared of going over numbers, I didn’t invite everyone I wanted, and in the end, I missed having some great friends there.” —"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LISA")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("“Really narrow down your guest list to the people "), _c('i', [_vm._v("you")]), _vm._v(" want to invite, not who your "), _c('i', [_vm._v("parents")]), _vm._v(" want to invite. My husband and I were married three and a half years ago, and I have no idea why I invited some of the people that I invited.” —"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TIFFANY")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-1t"
  }, [_c('b', [_vm._v("APPRECIATION")])]), _vm._v(" "), _c('p', {
    staticClass: "normalat"
  }, [_vm._v("“One thing that I think is still so important yet often overlooked is the thank-you note! After an occasion where you are on the receiving end of so much generosity and well-wishing, it is the least you can do, and I think it says a lot about you whether you do or don’t!” —"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SALLY")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-1t"
  }, [_c('b', [_vm._v("MONEY")])]), _vm._v(" "), _c('p', {
    staticClass: "normalat"
  }, [_vm._v("“As you plan, think how no day should cost more than a car. You will need several cars, a mortgage, college funds, savings, healthcare, and emergencies all your days together. Always, always say thank you for whatever gesture is made.” —"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("COLEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("“Save up, and don’t use credit to pay for your wedding.” —"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HERRY")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("“We are going with a grocery store cake, it will look great and taste just fine and we can spend money elsewhere. No one other than us will know the difference.” —"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MELISSA")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-1t"
  }, [_c('b', [_vm._v("DETAILS")])]), _vm._v(" "), _c('p', {
    staticClass: "normalat"
  }, [_vm._v("“Come the wedding day, I couldn’t have cared less about chair covers—and I have a feeling that not a single guest noticed. In retrospect, chair covers would have looked silly—but this topic definitely caused a major meltdown during wedding planning.” —"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SOPHIE")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("“Figure out what’s important to you, for example food, flowers, dress, and alcohol. Number them in the order of priority and stick to it! If it didn’t make the list then forget about it. It’s one less thing to spend money on or make a decision about.” —"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALYSON")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("“Have fun with the planning! Don’t get too caught up in all the little details or obsess about decisions to be made. Remind yourself that the whole purpose of the day is to celebrate your love and the beginning of your lives together.” —"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANNE MARIE")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("“There will inevitably be something that will go wrong or not be exactly as you wanted it, but your guests will never notice, and (hopefully!) you’ll be too blissfully happy on the big day to care.” —"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MORGAN")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-1t"
  }, [_c('b', [_vm._v("TAKE CARE OF YOURSELF")])]), _vm._v(" "), _c('p', {
    staticClass: "normalat"
  }, [_vm._v("“When bride and attendants are getting ready before ceremony, make sure to provide food and water so nobody goes to ceremony hungry or dehydrated. The bride and groom should make sure to eat at the reception.” —"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CAROLINE")])]), _vm._v(" "), _c('p', {
    staticClass: "normala"
  }, [_vm._v("“Don’t forget to eat!” —"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANDREA")])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')])]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("The More Things Change . . .")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Sometimes these changes can be confusing and stressful to sort through, especially when different generations have different traditions and expectations. Your wedding may be quite different from that of your parents or grandparents. While you all said (or will say), “I do,” the manners and traditions surrounding the wedding experience have changed over time. You may run into resistance or skepticism from upper-generation guests or family who expect that for a wedding to be “proper” it must conform to the manners of their day. Having families finance and host the wedding together may be a concept foreign and somewhat suspect to your grandmother, whose parents alone paid for and hosted her wedding. (And it’s still perfectly fine today if the bride’s family continues to do so.)")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("These differences of opinion and generational custom are not insurmountable. The best way to bend or break with a tradition is first to understand it. Why is it important, and did it serve a greater purpose that might make it worth holding on to, or at least still achieving another way? For example, you might not choose to send formal wedding invitations or announcements or have a receiving line, but we encourage you to read about them to give context to wedding traditions that have endured for generations. Knowing that you are aware of and have considered all your options will also go a long way to gaining support for more contemporary wedding ideas.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("The wedding questions we answer on a regular basis come from all quarters—brides, grooms, parents, attendants, guests, wedding professionals—and whether the asker wants to hold on to tradition or push forward, the questions all reflect a relaxing of “rules” and an increase in alternatives. Tradition for its own sake alone is hollow; it must have meaning and value to make it special. So long as the answer to a dilemma reflects thoughtfulness to the feelings and comfort of all who will be affected by it, practicality may indeed trump tradition—and may in turn create a new tradition of lasting significance.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Best Wishes")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Whatever questions and challenges come your way, we hope this book will give you the guidance you need. Most important, we hope you’ll have fun, whether your wedding is small and informal or grand and traditional. Really, all that’s needed for the “perfect” wedding is the love the bride and groom feel for each other, the confidence to make decisions, and the consideration to make sure that everyone involved is treated with courtesy. A sense of humor comes in handy, too, to help you negotiate any unexpected bumps along the way.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("As the two of you approach one of the most important days of your lives, just remember to keep the details in perspective and your happiness and joy in the forefront. May it all turn out beautifully—the perfect wedding for you.")]), _vm._v(" "), _c('p', {
    staticClass: "right-1"
  }, [_vm._v("ANNA POST")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("LIZZIE POST")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('i', [_vm._v("January 2014")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e32fe85e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062237088_Frontmatter_1.vue
// module id = 75
// module chunks = 0